module.exports = __webpack_public_path__ + "static/media/5_MR_Chips.361f15fc.png";